import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { ColetorCustosService } from 'src/app/_services';
import { FileUploadModel, RateioDespesas, ColetorCustos } from 'src/app/_models';
import {HttpClient} from '@angular/common/http';
import * as XLSX from 'xlsx';
import { ProtocoloComponent } from '../../_components/protocolo/protocolo.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PopUpColetoresComponent } from '../popupColetores/popupColetores.component';
import { AppComponent } from '../../app.component';
import { DocumentoService } from 'src/app/_services/documento.service';

@Component({
  selector: 'app-planilha',
  templateUrl: './planilha.component.html',
  styleUrls: ['./planilha.component.css']
})
export class PlanilhaComponent implements OnInit {
  type: string;
  private files: Array<FileUploadModel> = [];
  arrayBuffer: any;
  rateioDespesas = {} as RateioDespesas;
  lstRateiosDespesas = new Array<RateioDespesas>();
  coletoresCusto: ColetorCustos[];
  coletoresCustoError = new Array<ColetorCustos>();

  /** Link text */
  @Input() text = 'Upload';
  /** Name used in form which will be sent in HTTP request. */
  @Input() param = 'file';
  /** Target URL for file uploading. */
  @Input() target = 'https://file.io';
  /** File extension that accepted, same as 'accept' of <input type="file" />. 
      By the default, it's set to 'image/*'. */
  @Input() accept = '.xlsx';
  /** Allow you to add handler after its completion. Bubble up response text from remote. */
  @Output() complete = new EventEmitter<string>();


  constructor(
    private loadComponent: AppComponent,
    private documentoService: DocumentoService,
    private _http: HttpClient,
    private protocolo: ProtocoloComponent,
    private apiColetorCustos: ColetorCustosService,
    private dialog?: MatDialog,
  ) { }

  ngOnInit() {
    this.type = this.type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  getFile() {
    this.documentoService.getPlanilhaRateioNaoFiscal().subscribe(respData => {
      this.downLoadFile(respData, this.type);
    }, error => {

    });
  }

  downLoadFile(data: any, type: string) {
    const blob = new Blob([data], { type: type.toString() });
    const a = document.createElement('a');
    const fileURL = URL.createObjectURL(blob);
    a.href = fileURL;
    a.download = 'PlanilhaRateioNaoFiscal.xlsx';
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
    URL.revokeObjectURL(fileURL);
  }

  AnexarPlanilha() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push({
          data: file, state: 'in',
          inProgress: false, progress: 0, canRetry: false, canCancel: true
        });
      }
      this.uploadFiles();
    };
    fileUpload.click();
  }

  private uploadFile(file: FileUploadModel) {
    const fileReader = new FileReader();
    let codDespesaNaoEncontrado = '';
    let descricaoNaoEncontrado = false;
    let tipoColetorNaoEncontrado = false;
    let validacoesColetorCustosMensagens = '';

    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      const data = new Uint8Array(this.arrayBuffer);
      const arr = new Array();
      for (let i = 0; i !== data.length; ++i) { arr[i] = String.fromCharCode(data[i]); }
      const bstr = arr.join('');
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];
      let jsonPlanilha: Array<any>;
      jsonPlanilha = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      jsonPlanilha.forEach((p, index) => {
        this.rateioDespesas = {} as RateioDespesas;
        this.rateioDespesas.codDespesa = p.COD_DESPESA;

        if (this.protocolo.tipoDespesas.find(td => td.codDespesa == p.COD_DESPESA) != null) {
          this.rateioDespesas.nomeTipoDespesa = this.protocolo.tipoDespesas.find(td => td.codDespesa == p.COD_DESPESA).tipoDespesa;
        } else {
          codDespesaNaoEncontrado = p.COD_DESPESA;
          return;
        }

        if(p.TIPOCOLETOR === 'N' && p.COLETOR.toString().length > 12){
          validacoesColetorCustosMensagens += `<br>- Tipo de Coletor: <b>${p.TIPOCOLETOR} - ${p.COLETOR}</b> não pode conter mais de 12 caracteres. Linha: <b>${p.__rowNum__ + 1}.</b>`;
        }

        if(p.TIPOCOLETOR === 'K' && p.COLETOR.toString().length > 10){
          validacoesColetorCustosMensagens += `<br>- Tipo de Coletor: <b>${p.TIPOCOLETOR} - ${p.COLETOR}</b> não pode conter mais de 10 caracteres. Linha: <b>${p.__rowNum__ + 1}.</b>`
        }

        if (p.TIPOCOLETOR == null || p.TIPOCOLETOR === 'undefined' || p.TIPOCOLETOR === '') {
          tipoColetorNaoEncontrado = true;
          return;
        } else {
          this.rateioDespesas.codTipoColetor = p.TIPOCOLETOR.toUpperCase().replace(' ', '');
          this.rateioDespesas.identificacaoColetor = p.COLETOR;
          this.rateioDespesas.contaRazao = this.protocolo.tipoDespesas.find(td => td.codDespesa == p.COD_DESPESA).contaRazao;
        }

        if (p.DESCRICAO == null || p.DESCRICAO.value === '') {
          descricaoNaoEncontrado = true;
          return;
        } else {
          this.rateioDespesas.descricao = p.DESCRICAO;

        }

        this.rateioDespesas.usuarioAlteracao = this.protocolo.currentUser.login;
        this.rateioDespesas.usuarioCadastro = this.protocolo.currentUser.login;
              
        const valor = p.VALOR.toString().replace('R$', '').trim();
        const valorNumber = Number(valor.replace(',', '.')).toFixed(2);
        this.rateioDespesas.valor = Number(valorNumber);

        if (!tipoColetorNaoEncontrado) {
          if (this.rateioDespesas.codTipoColetor.toUpperCase().replace(' ', '') === 'N') {
            this.rateioDespesas.operacaoSubNumero = p.OPERACAO;
          }

          this.lstRateiosDespesas.push(this.rateioDespesas);
        }
      });

      // Valores de rateios
      const valRateioProtoloco = this.protocolo.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);
      const valRateioDespesas = this.lstRateiosDespesas.reduce((sum, c) => sum + c.valor, 0);
      const totalRateios = (Number(valRateioProtoloco.toFixed(2)) + Number(valRateioDespesas.toFixed(2)));

      if (totalRateios > this.protocolo.cabecalhoProtocolo.valor) {
        this.protocolo.ExibeMensagemValorRateios();
        this.rateioDespesas = {} as RateioDespesas;
        this.lstRateiosDespesas = new Array<RateioDespesas>();
        this.loadComponent.startLoading(false);
      } else {
        if(validacoesColetorCustosMensagens !== ''){
          this.protocolo.lstRateioDespesas = [];
          this.lstRateiosDespesas = [];
          this.protocolo.ExibeMensagemUpload('Erro ao realizar upload da planilha', validacoesColetorCustosMensagens);
        }else {
          this.ValidarDadosRateio(this.lstRateiosDespesas);
        }
      }

      if (codDespesaNaoEncontrado !== '') {
        this.protocolo.ExibeMensagemUpload('Erro ao realizar upload da planilha', `Código de despesa ${codDespesaNaoEncontrado} não encontrado para o tipo de documento selecionado.`);
        this.rateioDespesas = {} as RateioDespesas;
        this.lstRateiosDespesas = new Array<RateioDespesas>();
        this.loadComponent.startLoading(false);
      }

      if (descricaoNaoEncontrado) {
        this.protocolo.ExibeMensagemUpload('Erro ao realizar upload da planilha', `Descrição não pode ser um campo vazio.`);
        this.rateioDespesas = {} as RateioDespesas;
        this.lstRateiosDespesas = new Array<RateioDespesas>();
        this.loadComponent.startLoading(false);
      }

      if (tipoColetorNaoEncontrado) {
        this.protocolo.ExibeMensagemUpload('Erro ao realizar upload da planilha', `Coluna \"TIPOCOLETOR\" com registro(s) vazio ou nulo.`);
        this.rateioDespesas = {} as RateioDespesas;
        this.lstRateiosDespesas = new Array<RateioDespesas>();
        this.loadComponent.startLoading(false);
      }

      this.removeFileFromArray(file);

    };
    fileReader.readAsArrayBuffer(file.data);
  }

  ValidarDadosRateio(rateios: RateioDespesas[]) {
    this.apiColetorCustos.validateColetoresCustos(rateios, this.protocolo.empresaMRV.codigoEmp,
      this.protocolo.cabecalhoProtocolo.divisao, null, null)
      .subscribe(
        data => this.coletoresCusto = data.data,
        err => {
          console.error(err);
          this.loadComponent.startLoading(false);
        },
        () => {
          if (this.coletoresCusto != null) {
            this.VerificaColetoresInvalidos(this.coletoresCusto);
            this.protocolo.verifingColetor = false;
          }

          this.loadComponent.startLoading(false);
        });
  }

  private VerificaColetoresInvalidos(coletores: ColetorCustos[]) {
    let idx = 0;
    this.coletoresCustoError = new Array<ColetorCustos>();

    coletores.forEach(cc => {
      idx++;
      console.log(cc.status);
      if (cc.status === 'E') {
        this.coletoresCustoError.push(cc);
      }
    });

    if (this.coletoresCustoError.length > 0) {
      this.dialog.open(PopUpColetoresComponent, { data: this.coletoresCustoError });
      this.lstRateiosDespesas = new Array<RateioDespesas>();
    } else {
      this.IncluirRateioDataSource();
    }
  }

  private IncluirRateioDataSource() {

    this.lstRateiosDespesas.forEach(r => this.protocolo.lstRateioDespesas.push(r));
    this.protocolo.dataSource = new MatTableDataSource<RateioDespesas>(this.protocolo.lstRateioDespesas);
    this.protocolo.dataSource.paginator = this.protocolo.paginator;
    this.protocolo.somaRateio = this.protocolo.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);
    this.protocolo.somaRateio = Number(this.protocolo.somaRateio.toFixed(5));
    this.rateioDespesas = {} as RateioDespesas;
    this.lstRateiosDespesas = new Array<RateioDespesas>();
  }

  private removeFileFromArray(file: FileUploadModel) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }

  private uploadFiles() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.value = '';

    this.files.forEach(file => {
      this.uploadFile(file);
    });
  }
}
